import { InjectionToken, ValueProvider } from '@angular/core';
import * as dayjs from 'dayjs';

const DayJs = new InjectionToken('dayjs');
const DayJsProvider: ValueProvider = { provide: DayJs, useValue: dayjs };
export { DayJs, DayJsProvider };
